import { useEffect } from "react";

//#region src/hooks/useAsyncEffect.ts
function useAsyncEffect(effect, deps) {
	useEffect(() => {
		let cancelled = false;
		let cleanup;
		const runCleanup = () => {
			if (cleanup) {
				const result = cleanup();
				if (result && typeof result.then === "function") result.catch((error) => {
					console.error("Error in useAsyncEffect cleanup:", error);
				});
			}
		};
		const runEffect = async () => {
			try {
				cleanup = await effect();
				if (cancelled) runCleanup();
			} catch (error) {
				if (!cancelled) console.error("Error in useAsyncEffect:", error);
			}
		};
		runEffect();
		return () => {
			cancelled = true;
			runCleanup();
		};
	}, deps);
}

//#endregion
export { useAsyncEffect };